export enum SpinnerSize {
  XLarge = 'xlg',
  Large = 'lg',
  Medium = 'md',
  Small = 'sm',
  XSmall = 'xsm',
}
